export const existy = (obj) => {
    return obj != null;
};

export const isDefined = (obj) => {
    let flag = true;
    if (obj === null || typeof obj === 'undefined') return false;
    return flag;
};

export const isString = (obj) => {
    if (!isDefined(obj)) return false;
    return (obj.constructor === String);
};

export let isInteger = (obj) => {
    if (!isDefined(obj) || obj.constructor !== Number) return false;

    // https://developer.mozilla.org/ko/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
    return (isFinite(obj) && Math.floor(obj) === obj);
};

export const isObject = (obj) => {
    if (!isDefined(obj)) return false;
    return (obj.constructor === Object);
};

export const isFunction = (obj) => {
    if (!isDefined(obj)) return false;
    return (obj.constructor === Function);
};

export const not = (func) => {
    if (!isFunction(func)) throw new TypeError('func parameter type of not() must be Function.');

    return (object) => {
        return !func(object);
    };
};

export const isNotDef = not(isDefined);

export const each = (dataCanLoop, func, context) => {
    let _context = (existy(context)) ? context : null;

    if (!(Array.isArray(dataCanLoop) || isString(dataCanLoop))) throw new TypeError('dataCanLoop parameter type of each() must be Array or String.');

    let result = false;
    for (let i = 0, max = dataCanLoop.length; i < max; i++) {
        result = func.call(_context, dataCanLoop[i]);
        if (result === false) break;
    }
};

export const parseInt10 = (number) => {
    return parseInt(number, 10);
};

export const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const parseTwoDigits = (number) => {
    number *= 1;
    return number < 10 ? `0${number}` : number;
};

export const isPassed = (timeA, timeB) => {
    const date = new Date();
    let dateA = new Date(date);
    let dateB = new Date(date);
    dateA.setHours(timeA.split(':')[0]);
    dateA.setMinutes(timeA.split(':')[1]);
    dateB.setHours(timeB.split(':')[0]);
    dateB.setMinutes(timeB.split(':')[1]);
    return dateA < dateB;
};

export const getTodayStatus = (timeA, timeAEnd, timeB) => {
    const date = new Date();
    let dateA = new Date(date);
    let dateAEnd = new Date(date);
    let dateB = new Date(date);
    let status;
    dateA.setHours(timeA.split(':')[0]);
    dateA.setMinutes(timeA.split(':')[1]);

    dateAEnd.setHours(timeAEnd.split(':')[0]);
    dateAEnd.setMinutes(timeAEnd.split(':')[1]);

    // let _timeB = "05:30";
    dateB.setHours(timeB.split(':')[0]);
    dateB.setMinutes(timeB.split(':')[1]);
    // return dateA < dateB;
    if(dateA < dateAEnd ) { // 익일이 아닌 경우
        status = (dateAEnd < dateB) ? `disabled` : (dateA < dateB) ? `now`:  ``;
    } else {
        status = (dateA < dateB || dateAEnd > dateB ) ? `now` :  ``;
        console.log('## status : ', status, '/ dateB: ', dateB, '/ dateA: ', dateA, '/ dateAEnd:', dateAEnd);
    }

    return status;

};

export const getTimeformat = (time) => {
    const hour = (time.split(':')[0] > 24) ? time.split(':')[0] - 24 : time.split(':')[0];
    const minute = time.split(':')[1];

    return `${parseTwoDigits(hour)}:${parseTwoDigits(minute)}`;
};

export let namespace = (namespace, parent) => {
    if (!isString(namespace)) throw new TypeError('namespace parameter type of namespace() must be String.');
    if (!(isObject(parent) || !isDefined(parent))) throw new TypeError('parent parameter type of namespace() must be Object or null or undefined.');

    let ns = parent || window;

    if (namespace) {
        let parts = namespace.split('.');

        for (let i = 0, max = parts.length; i < max; i++) {
        if (!ns[parts[i]]) ns[parts[i]] = {};
        ns = ns[parts[i]];
        }
    }

    return ns;
};
  
  
  


// WEBPACK FOOTER //
// ./_src/js/schedule/util.js